module.exports = __webpack_public_path__ + "img/CosmeticBags.7ac946f8.png";